import { Component } from '@angular/core';

@Component({
  selector: 'app-idle-iframe',
  template: `<div class="idle-iframe"></div>`,
})
export class IdleIframeComponent {}
